































import { Booking } from '@bookings/interfaces/booking';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bc-public-booking-request-cancel-modal',
  components: {},
})
export default class PublicBookingRequestCancelModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ default: null }) readonly booking!: Booking;
  @Prop({ type: String, default: 'public-booking-request-cancel-modal' })
  readonly cancelModalId: string;
  @Prop({ type: String, default: 'global.modals.booking-request-cancel.title' })
  readonly modalTitle: string;
  @Prop({ type: String, default: 'global.modals.booking-request-cancel.body' })
  readonly modalBody: string;

  //const :

  //variable
  public cancelReasonOptionSelected: string = '';
  public showCancellingSpinner: boolean = false;
  public permissionEntityNameToUse = 'bookings';
  public pluralEntityName = 'booking-events';

  //METHODS
  closeModal() {
    this.$emit('close-modal');
  }

  onConfirm() {
    this.showCancellingSpinner = true;

    const hasCancelPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'cancel_booking',
    );

    const hasCancelOwnPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'cancel',
      true,
    );
    const hasPublicCancelPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'manage_public_bookings',
      true,
    );

    const hasPermissionToCancel = hasCancelOwnPermission || hasPublicCancelPermission;
    if (hasPermissionToCancel) {
      const basePath = this.$bpcApiRouteHelper.getEntityPath('booking');
      this.$bpcApi
        .post(basePath + '/public/cancel', {
          bookings: [this.booking.id],
          cancelReason: 'customer',
          cancelReasonDescription: '',
          cancelOrders: true,
          notify_by_email: false, // TODO: JJFC check with Simon
        })
        .subscribe(
          res => {
            this.showCancellingSpinner = false;
            this.$bvModal.hide(this.cancelModalId);
            this.$emit('booking-cancelled');
          },
          error => {
            this.showCancellingSpinner = false;
            this.$bvModal.hide(this.cancelModalId);
          },
        );
    } else {
      this.showCancellingSpinner = false;
      this.$bvModal.msgBoxOk(
        this.$t('global.modals.public_booking.cancellation.not_possible_by_permissions').toString(),
        {
          title: this.$t('global.modals.public_booking.cancellation.title').toString(),
          okTitle: this.$t('global.buttons.close').toString(),
        },
      );
    }
  }
}
